import React, { useState, useCallback, useRef, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap'; // Ensure react-bootstrap is installed
import EvaluationListTranslation from './EvaluationListTranslation';
import SelectWithLabel from "components/UI/SelectWithLabel";
import ToggleSwitch from 'components/Common/ToggleSwitch';
import { ReactDataContext } from "@themost/react";
import StudentDataFilesComponentTranslation from 'components/Application/Outgoing/Form/translations/StudentDataFilesComponentTranslation';

const EvaluationEditModal = ({
	show,
	onClose,
	langCode,
	selectedRow,
	userService
}) => {

	const getCookie = (name) => {
		const cookie = {}
		document.cookie.split(';').forEach((e) => {
			const [key, value] = e.split('=');
			cookie[key.trim()] = value;
		})
		return cookie[name];
	}
	const context = new ReactDataContext(process.env.REACT_APP_API_SERVER);
	context.setBearerAuthorization(userService.getToken());
	const [studyLevel, setStudyLevel] = useState(selectedRow?.studiesData?.studyCycle);
	const [user, setUser] = useState(JSON.parse(localStorage.getItem("role")).role);
	const [userEmail, setUserEmail] = useState(JSON.parse(getCookie("user").split(';').reduce((cookieObject, cookieString) => {
		let splitCookie = cookieString.split('=').map((cookiePart) => { cookiePart.trim() })
		try {
			cookieObject[splitCookie[0]] = JSON.parse(splitCookie[1])
		} catch (error) {
			cookieObject[splitCookie[0]] = splitCookie[1]
		}
		return cookieObject
	})))
	const [isEctsCoordHome, setIsEctsCoordHome] = useState(false);
	const [isEctsCoordPartner, setIsEctsCoordPartner] = useState(false);
	const [applicationStudy, setApplicationStudy] = useState(selectedRow?.application);
	const [selectedRowModal, setSelectedRowModal] = useState(selectedRow);




	useEffect(() => {

		setStudyLevel(selectedRow?.application.studiesData[0].studyCycle);
		setApplicationStudy(selectedRow?.application);
		setSelectedRowModal(selectedRow);
		const init = async () => {
			const res = await context.model(`MobilityContacts`).asQueryable().where("email").
				equal(userEmail.email).getItem();
			// TODO temporary hotfix: return the lines bellow the first
			setIsEctsCoordHome(true);
			//   if (selectedRow.application.studiesData[0].department.id === res[0].department.id) {
			//     setIsEctsCoordHome(true);
			// }
			// else {
			//     setIsEctsCoordPartner(true);
			// }
		}
		init();










	}, []);


	const handleInputChangeAverage = (e) => {

		const { value } = e.target;
		const applicationS = { ...applicationStudy };
		const selectedRowTemp = { ...selectedRowModal };

		selectedRowTemp.mobility.evaluationData[0].average = value;

		applicationS.prefferedMobility[selectedRow?.prefIndex].evaluationData[0].average = value;

		setApplicationStudy(applicationS);
		setSelectedRowModal(selectedRowTemp);

	};

	const handleInputChangeCurrentSemester = (e) => {

		const { value } = e.target;
		const applicationS = { ...applicationStudy };
		const selectedRowTemp = { ...selectedRowModal };

		selectedRowTemp.mobility.evaluationData[0].currentSemester = value;

		applicationS.prefferedMobility[selectedRow?.prefIndex].evaluationData[0].currentSemester = value;

		setApplicationStudy(applicationS);
		setSelectedRowModal(selectedRowTemp);
	};

	const handleInputChangeEctsComments = (e) => {

		const { value } = e.target;
		const applicationS = { ...applicationStudy };
		const selectedRowTemp = { ...selectedRowModal };

		selectedRowTemp.mobility.evaluationData[0].ectsComments = value;

		applicationS.prefferedMobility[selectedRow?.prefIndex].evaluationData[0].ectsComments = value;

		setApplicationStudy(applicationS);
		setSelectedRowModal(selectedRowTemp);
	};

	const handleInputChangePositionAvailabilityComments = (e) => {

		const { value } = e.target;
		const applicationS = { ...applicationStudy };
		const selectedRowTemp = { ...selectedRowModal };

		selectedRowTemp.mobility.evaluationData[0].positionAvailabilityComments = value;

		applicationS.prefferedMobility[selectedRow?.prefIndex].evaluationData[0].positionAvailabilityComments = value;

		setApplicationStudy(applicationS);
		setSelectedRowModal(selectedRowTemp);
	};

	const handleOnChange = value => {
		// const { value } = e.target;
		const applicationS = { ...applicationStudy };
		const selectedRowTemp = { ...selectedRowModal };

		selectedRowTemp.application.specialNeedsCategory = value;

		applicationS.prefferedMobility[selectedRow?.prefIndex].evaluationData[0].specialNeedsCategory = value;

		setApplicationStudy(applicationS);
		setSelectedRowModal(selectedRowTemp);
	};

	const handleOnChangePositionAvailability = value => {
		// const { value } = e.target;
		const applicationS = { ...applicationStudy };
		const selectedRowTemp = { ...selectedRowModal };

		selectedRowTemp.mobility.evaluationData[0].positionAvailability = value;

		applicationS.prefferedMobility[selectedRow?.prefIndex].evaluationData[0].positionAvailability = value;

		setApplicationStudy(applicationS);
		setSelectedRowModal(selectedRowTemp);
	};

	const handleOnChangePastMobility = value => {
		// const { value } = e.target;
		const applicationS = { ...applicationStudy };
		const selectedRowTemp = { ...selectedRowModal };

		selectedRowTemp.mobility.evaluationData[0].pastMobility = value;

		applicationS.prefferedMobility[selectedRow?.prefIndex].evaluationData[0].pastMobility = value;

		setApplicationStudy(applicationS);
		setSelectedRowModal(selectedRowTemp);
	};

	const handleSave = () => {

		context.model('ApplicationStudentStudiesForms').save(applicationStudy).then(res => {

			onClose();
		}).catch(err => console.log(err))

	};

	const downloadPdf = async (id) => {
		try {
			console.log(id)
			const filesResponse = await context.model('ApplicationFiles').asQueryable().where('id').equal(id).take(-1).getItems()
			console.log(filesResponse)
			const fileSource = "data:application/pdf;base64," + filesResponse[0].fileBase64
			const link = document.createElement('a');
			const fileName = filesResponse[0].fileName;

			link.href = fileSource
			link.download = fileName
			link.click();
		} catch (err) {
			console.log(err)
		}
	}

	return (
		<Modal show={show} onHide={onClose} centered>
			<Modal.Header closeButton>
				<Modal.Title>Application Details</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<table className="table">
					<tbody>
						<tr>
							<th>{EvaluationListTranslation("fullNameList", langCode)['label']}</th>
							<td>{langCode === 'en' ? selectedRow?.application?.studentData?.[0]?.familyNameLatin + " " + selectedRow?.application?.studentData?.[0]?.nameLatin : selectedRow?.application?.studentData?.[0]?.familyNameGreek + " " + selectedRow?.application?.studentData?.[0]?.nameGreek}</td>
						</tr>
						<tr>
							<th>{EvaluationListTranslation("id", langCode)['label']}</th>
							<td>{selectedRow?.application?.applicationNumber}</td>
						</tr>
						<tr>
							<th>{EvaluationListTranslation("averageGrade", langCode)['label']}</th>
							<td>{user === "IRO" && (studyLevel === 7 || studyLevel === 8) ?
								<input
									value={selectedRowModal?.mobility?.evaluationData[0].average}
									name="averageGrade"
									onChange={(e) => handleInputChangeAverage(e)}
								/> :
								selectedRow?.mobility?.evaluationData[0].average}</td>
						</tr>
						{studyLevel === "6" && <tr>
							<th>{"ECTS"}</th>
							<td>{
								selectedRow?.mobility?.evaluationData[0].ects}</td>
						</tr>}
						<tr>
							<th>{"Τρέχον εξάμηνο σπουδών"}</th>
							<td>{user === "IRO" && (studyLevel === 7 || studyLevel === 8) ?
								<input
									value={selectedRowModal?.mobility?.evaluationData[0].currentSemester}
									name="currentSemester"
									onChange={(e) => handleInputChangeCurrentSemester(e)}
								/> :
								selectedRow?.mobility?.evaluationData[0].currentSemester}
							</td>
						</tr>
						<tr>
							<th>{studyLevel === 7 ? "Σύνολο εξαμήνων για την ολοκλήρωση του μεταπτυχιακού" : "Σύνολο ετών για την ολοκλήρωση του διδακτορικού"}</th>
							<td>{user === "IRO" && (studyLevel === "7" || studyLevel === "8") ?
								<SelectWithLabel
									value={selectedRowModal?.mobility?.evaluationData[0].studyProgramSemesters}
									onSelectChange={(e) => {
										if (e !== null) {
											const applicationS = { ...applicationStudy };
											const selectedRowTemp = { ...selectedRowModal };

											applicationS.prefferedMobility[selectedRow?.prefIndex].evaluationData[0].studyProgramSemesters = e.value;
											selectedRowTemp.mobility.evaluationData[0].studyProgramSemesters = e.value;

											setApplicationStudy(applicationS);
											setSelectedRowModal(selectedRowTemp);
										} else {
											const applicationS = { ...applicationStudy };
											const selectedRowTemp = { ...selectedRowModal };

											selectedRowTemp.mobility.evaluationData[0].studyProgramSemesters = null;
											applicationS.prefferedMobility[selectedRow?.prefIndex].evaluationData[0].studyProgramSemesters = null;

											setApplicationStudy(applicationS);
											setSelectedRowModal(selectedRowTemp);
										}
									}}
									id="sortSelected"
									//placeholderText={EvaluationListTranslation("sorting", langCode)['label']}
									clearable={true}
									listOptions={studyLevel === "7" ? [
										{ label: "2", value: "2" },
										{ label: "3", value: "3" },
										{ label: "4", value: "4" },
									] : [
										{ label: "5", value: "5" },
										{ label: "6", value: "6" },]
									}
								>

								</SelectWithLabel> :
								selectedRow?.mobility?.evaluationData[0].studyProgramSemesters}
							</td>
						</tr>
						<tr>
							<th>{"Ανήκει στην κατηγορία των ατόμων με αναπηρία/ειδικές ανάγκες"}</th>
							<td>
								{/* <ToggleSwitch
                    small
                    // id={id} 
                    // name={`local-factsheet-switch`}
                    disabled={user !== "IRO"}
                    checked={selectedRowModal?.application?.specialNeedsCategory}
                    onChange={handleOnChange}
                /> */}
								<input
									type="checkbox"
									// className="toggle-switch-checkbox"

									checked={selectedRowModal?.application?.specialNeedsCategory}
									onChange={e => handleOnChange(e.target.checked)}
									disabled={user !== "IRO"}
								/></td>
						</tr>
						<tr>
							<th>{"Προηγούμενη μετακίνηση"}</th>
							<td><input
								type="checkbox"
								// className="toggle-switch-checkbox"

								checked={selectedRowModal?.mobility?.evaluationData[0].pastMobility === null ? selectedRowModal?.application?.pastMobilityData?.length > 0 : selectedRowModal?.mobility?.evaluationData[0].pastMobility}
								onChange={e => handleOnChangePastMobility(e.target.checked)}
								disabled={user !== "IRO"}
							/></td>
						</tr>
						<tr>
							<th>{"Σχόλια παραλαβής αίτησης"}</th>
							<td>{
								selectedRow?.application?.applicationComments}</td>
						</tr>
						<tr>
							<th>{"Αρχεία"}</th>
							<td>
								{selectedRowModal?.application?.filesData?.length > 0 ? <>{selectedRowModal?.application?.filesData[0]?.europassCv && <div className="form-group mb-3">
									<label for="formFile" class="form-label">{StudentDataFilesComponentTranslation("europassCv", langCode)['label']}</label>

									<div>
										<button className='btn btn-primary' type="button" onClick={() => downloadPdf(selectedRowModal?.application?.filesData[0]?.europassCv)}><i className="fa fa-download mr-2"></i>{StudentDataFilesComponentTranslation("download_btn", langCode)['label']}</button>
									</div>

								</div>}
									{selectedRowModal?.application?.filesData[0]?.academicIdentity && <div className="form-group mb-3">
										<label for="formFile" class="form-label">{StudentDataFilesComponentTranslation("academicIdentity", langCode)['label']}</label>

										<div className="input-group">
											<button className='btn btn-primary' type="button" onClick={() => downloadPdf(selectedRowModal?.application?.filesData[0]?.academicIdentity)}><i className="fa fa-download mr-2"></i>{StudentDataFilesComponentTranslation("download_btn", langCode)['label']}</button>
										</div>

									</div>}
									{selectedRowModal?.application?.filesData[0]?.proposedCurriculum && <div className="form-group mb-3">
										<label for="formFile" class="form-label">{StudentDataFilesComponentTranslation("proposedCurriculum", langCode)['label']}</label>

										<div className="input-group">
											<button className='btn btn-primary' type="button" onClick={() => downloadPdf(selectedRowModal?.application?.filesData[0]?.proposedCurriculum)}><i className="fa fa-download mr-2"></i>{StudentDataFilesComponentTranslation("download_btn", langCode)['label']}</button>
										</div>
									</div>}
									{selectedRowModal?.application?.filesData[0]?.foreignLanguageCertificate && <div className="form-group mb-3">
										<label for="formFile" class="form-label">{StudentDataFilesComponentTranslation("foreignLanguageCertificate", langCode)['label']}</label>

										<div className="input-group">
											<button className='btn btn-primary' type="button" onClick={() => downloadPdf(selectedRowModal?.application?.filesData[0]?.foreignLanguageCertificate)}><i className="fa fa-download mr-2"></i>{StudentDataFilesComponentTranslation("download_btn", langCode)['label']}</button>
										</div>
									</div>}
									{selectedRowModal?.application?.filesData[0]?.detailedDegreeScore && <div className="form-group mb-3">
										<label for="formFile" class="form-label">{StudentDataFilesComponentTranslation("detailedDegreeScore", langCode)['label']}</label>

										<div className="input-group">
											<button className='btn btn-primary' type="button" onClick={() => downloadPdf(selectedRowModal?.application?.filesData[0]?.detailedDegreeScore)}><i className="fa fa-download mr-2"></i>{StudentDataFilesComponentTranslation("download_btn", langCode)['label']}</button>
										</div>
									</div>}
									{selectedRowModal?.application?.filesData[0]?.detailedMastersDegreeScore && <div className="form-group mb-3">
										<label for="formFile" class="form-label">{StudentDataFilesComponentTranslation("detailedMastersDegreeScore", langCode)['label']}</label>

										<div className="input-group">
											<button className='btn btn-primary' type="button" onClick={() => downloadPdf(selectedRowModal?.application?.filesData[0]?.detailedMastersDegreeScore)}><i className="fa fa-download mr-2"></i>{StudentDataFilesComponentTranslation("download_btn", langCode)['label']}</button>
										</div>
									</div>}

									<>
										{selectedRowModal?.application?.filesData[0]?.detailedMastersDegreeScore && <div className="form-group mb-3">
											<label for="formFile" class="form-label">{StudentDataFilesComponentTranslation("letterOfAcceptance", langCode)['label']}</label>

											<div className="input-group">
												<button className='btn btn-primary' type="button" onClick={() => downloadPdf(selectedRowModal?.application?.filesData[0]?.detailedMastersDegreeScore)}><i className="fa fa-download mr-2"></i>{StudentDataFilesComponentTranslation("download_btn", langCode)['label']}</button>
											</div>
										</div>}
										{selectedRowModal?.application?.filesData[0]?.recommendationLetter && <div className="form-group mb-3">
											<label for="formFile" class="form-label">{StudentDataFilesComponentTranslation("recommendationLetter", langCode)['label']}</label>

											<div className="input-group">
												<button className='btn btn-primary' type="button" onClick={() => downloadPdf(selectedRowModal?.application?.filesData[0]?.recommendationLetter)}><i className="fa fa-download mr-2"></i>{StudentDataFilesComponentTranslation("download_btn", langCode)['label']}</button>
											</div>
										</div>}
									</>

									{selectedRowModal?.application?.filesData[0]?.disabilityCertificate && <div className="form-group mb-3">
										<label for="formFile" class="form-label">{StudentDataFilesComponentTranslation("disabilityCertificate", langCode)['label']}</label>

										<div className="input-group">
											<button className='btn btn-primary' type="button" onClick={() => downloadPdf(selectedRowModal?.application?.filesData[0]?.disabilityCertificate)}><i className="fa fa-download mr-2"></i>{StudentDataFilesComponentTranslation("download_btn", langCode)['label']}</button>
										</div>
									</div>}</> : <></>}
							</td>
						</tr>
						<tr>
							<th>{"Γλώσσα"}</th>
							<td>{
								user === "IRO" || isEctsCoordHome ?
									<SelectWithLabel
										value={
											selectedRowModal?.application?.languageData
												?.find(
													(el) =>
														el.language.id ===
														selectedRowModal?.mobility?.evaluationData?.[0]?.language
												)
												?.language?.languageName
										}
										onSelectChange={(e) => {
											if (e !== null) {
												const applicationS = { ...applicationStudy };
												const selectedRowTemp = { ...selectedRowModal };

												selectedRowTemp.mobility.evaluationData[0].language = e.value;
												applicationS.prefferedMobility[selectedRow?.prefIndex].evaluationData[0].language = e.value;

												setApplicationStudy(applicationS);
												setSelectedRowModal(selectedRowTemp);
											} else {
												const applicationS = { ...applicationStudy };
												const selectedRowTemp = { ...selectedRowModal };

												selectedRowTemp.mobility.evaluationData[0].language = null;
												applicationS.prefferedMobility[selectedRow?.prefIndex].evaluationData[0].language = null;

												setApplicationStudy(applicationS);
												setSelectedRowModal(selectedRowTemp);
											}
										}}
										id="sortSelected1"
										//placeholderText={EvaluationListTranslation("sorting", langCode)['label']}
										clearable={true}
										listOptions={
											selectedRowModal?.application?.languageData?.map((el) => ({
												label: el.language.languageName,
												value: el.language.id,
											})) ?? []
										}
									>

									</SelectWithLabel> :
									selectedRowModal?.application?.languageData
										?.find(
											(el) =>
												el.language.id ===
												selectedRowModal?.mobility?.evaluationData?.[0]?.language
										)
										?.language?.languageName}</td>
						</tr>
						<tr>
							<th>{EvaluationListTranslation("languageLevel", langCode)['label']}</th>
							<td>{
								user === "IRO" || isEctsCoordHome ?
									<SelectWithLabel
										value={selectedRowModal?.mobility?.evaluationData[0].languageLevel}
										onSelectChange={(e) => {
											if (e !== null) {
												const applicationS = { ...applicationStudy };
												const selectedRowTemp = { ...selectedRowModal };

												selectedRowTemp.mobility.evaluationData[0].languageLevel = e.value;
												applicationS.prefferedMobility[selectedRow?.prefIndex].evaluationData[0].languageLevel = e.value;

												setApplicationStudy(applicationS);
												setSelectedRowModal(selectedRowTemp);
											} else {
												const applicationS = { ...applicationStudy };
												const selectedRowTemp = { ...selectedRowModal };

												selectedRowTemp.mobility.evaluationData[0].languageLevel = null;
												applicationS.prefferedMobility[selectedRow?.prefIndex].evaluationData[0].languageLevel = null;

												setApplicationStudy(applicationS);
												setSelectedRowModal(selectedRowTemp);
											}
										}}
										id="sortSelected1"
										//placeholderText={EvaluationListTranslation("sorting", langCode)['label']}
										clearable={true}
										listOptions={[
											{ label: "Βεβαίωση παρακoλούθησης μαθημάτων", value: "A1" },
											{ label: "Α2 ή επιτυχής εξέταση 4 προπτυχιακών μαθημάτων Ξένης γλώσσας", value: "A2" },
											{ label: "Β1", value: "Β1" },
											{ label: "Β2", value: "Β2" },
											{ label: "C1", value: "C1" },
											{ label: "C2 ή απολυτήριο δευτεροβάθμιας εκπαίδευσης", value: "C2" },
										]
										}
									>

									</SelectWithLabel> :
									selectedRowModal?.mobility?.evaluationData[0].languageLevel}</td>
						</tr>
						<tr>
							<th>{"1η γλώσσα"}</th>
							<td>{
								user === "IRO" || isEctsCoordHome ?
									<SelectWithLabel
										value={selectedRowModal?.mobility?.evaluationData[0].firstLanguage ? "Eίναι η πρώτη γλώσσα διδασκαλίας" : selectedRowModal?.mobility?.evaluationData[0].firstLanguage === false ? "Eίναι η δεύτερη γλώσσα διδασκαλίας" : null}
										onSelectChange={(e) => {
											if (e !== null) {
												const applicationS = { ...applicationStudy };
												const selectedRowTemp = { ...selectedRowModal };

												selectedRowTemp.mobility.evaluationData[0].firstLanguage = e.value;
												applicationS.prefferedMobility[selectedRow?.prefIndex].evaluationData[0].firstLanguage = e.value;

												setApplicationStudy(applicationS);
												setSelectedRowModal(selectedRowTemp);
											} else {
												const applicationS = { ...applicationStudy };
												const selectedRowTemp = { ...selectedRowModal };

												selectedRowTemp.mobility.evaluationData[0].firstLanguage = null;
												applicationS.prefferedMobility[selectedRow?.prefIndex].evaluationData[0].firstLanguage = null;

												setApplicationStudy(applicationS);
												setSelectedRowModal(selectedRowTemp);
											}
										}}
										id="sortSelected1"
										//placeholderText={EvaluationListTranslation("sorting", langCode)['label']}
										clearable={true}
										listOptions={[
											{ label: "Eίναι η πρώτη γλώσσα διδασκαλίας", value: true },
											{ label: "Eίναι η δεύτερη γλώσσα διδασκαλίας", value: false },
										]
										}
									>

									</SelectWithLabel> :
									<ToggleSwitch
										small
										// id={id} 
										// name={`local-factsheet-switch`}
										disabled={true}
										checked={selectedRowModal?.mobility?.evaluationData[0].languageLevel}
									/>}</td>
						</tr>
						<tr>
							<th>{"Κίνητρα"}</th>
							<td>{
								user === "IRO" || isEctsCoordHome ?
									<SelectWithLabel
										value={selectedRowModal?.mobility?.evaluationData[0].v5}
										onSelectChange={(e) => {
											if (e !== null) {
												const applicationS = { ...applicationStudy };
												const selectedRowTemp = { ...selectedRowModal };

												selectedRowTemp.mobility.evaluationData[0].v5 = e.value;
												applicationS.prefferedMobility[selectedRow?.prefIndex].evaluationData[0].v5 = e.value;

												setApplicationStudy(applicationS);
												setSelectedRowModal(selectedRowTemp);
											} else {
												const applicationS = { ...applicationStudy };
												const selectedRowTemp = { ...selectedRowModal };

												selectedRowTemp.mobility.evaluationData[0].v5 = null;
												applicationS.prefferedMobility[selectedRow?.prefIndex].evaluationData[0].v5 = null;

												setApplicationStudy(applicationS);
												setSelectedRowModal(selectedRowTemp);
											}
										}}
										id="sortSelected1"
										//placeholderText={EvaluationListTranslation("sorting", langCode)['label']}
										clearable={true}
										listOptions={[
											{ label: "0", value: 0 },
											{ label: "0.5", value: 0.5 },
											{ label: "1", value: 1 },
										]
										}
									>

									</SelectWithLabel> :
									selectedRowModal?.mobility?.evaluationData[0].v5}</td>
						</tr>
						<tr>
							<th>{"Σχόλια ECTS coordinator"}</th>
							<td>{user === "IRO" || isEctsCoordHome ?
								<textarea rows="3" style={{ width: "100%" }}

									value={selectedRowModal?.mobility?.evaluationData[0].ectsComments}
									name="ectsComments"
									onChange={(e) => handleInputChangeEctsComments(e)}
								/> :
								selectedRow?.mobility?.evaluationData[0].ectsComments}
							</td>
						</tr>
						{isEctsCoordPartner && <><tr>
							<th>{"Διάθεση θέσης"}</th>
							<td>
								<SelectWithLabel
									value={selectedRowModal?.mobility?.evaluationData[0].positionAvailability ? "Ναι" : selectedRowModal?.mobility?.evaluationData[0].positionAvailability === false ? "Όχι" : null}
									onSelectChange={(e) => {
										if (e !== null) {
											const applicationS = { ...applicationStudy };
											const selectedRowTemp = { ...selectedRowModal };

											selectedRowTemp.mobility.evaluationData[0].positionAvailability = e.value;

											applicationS.prefferedMobility[selectedRow?.prefIndex].evaluationData[0].positionAvailability = e.value;

											setApplicationStudy(applicationS);
											setSelectedRowModal(selectedRowTemp);
										} else {
											const applicationS = { ...applicationStudy };
											const selectedRowTemp = { ...selectedRowModal };

											selectedRowTemp.mobility.evaluationData[0].positionAvailability = null;
											applicationS.prefferedMobility[selectedRow?.prefIndex].evaluationData[0].positionAvailability = null;

											setApplicationStudy(applicationS);
											setSelectedRowModal(selectedRowTemp);
										}
									}}
									id="sortSelected1"
									//placeholderText={EvaluationListTranslation("sorting", langCode)['label']}
									clearable={true}
									listOptions={[
										{ label: "Ναι", value: true },
										{ label: "Όχι", value: false },
									]
									}
								>

								</SelectWithLabel>
								{/* <input
                type="checkbox"
                // className="toggle-switch-checkbox"
                
                checked={selectedRowModal?.mobility?.evaluationData[0].positionAvailability}
                onChange={e => handleOnChangePositionAvailability(e.target.checked)}
                disabled={!isEctsCoordPartner}/> */}
							</td>
						</tr>
							<tr>
								<th>{"Σχόλια διάθεσης θέσης"}</th>
								<td>{isEctsCoordPartner ?
									<textarea rows="3" style={{ width: "100%" }}
										value={selectedRowModal?.mobility?.evaluationData[0].positionAvailabilityComments}
										name="positionAvailabilityComments"
										onChange={(e) => handleInputChangePositionAvailabilityComments(e)}
									/> :
									selectedRow?.mobility?.evaluationData[0].positionAvailabilityComments}
								</td>
							</tr></>}

					</tbody>
				</table>
			</Modal.Body>
			<Modal.Footer>
				<Button className="btn btn-cancel m-2" onClick={handleSave}>
					Save
				</Button>
				<Button variant="secondary" onClick={onClose}>
					Close
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default EvaluationEditModal;
